import ToastHighLighter from '@/lib/ToastHighLighter';

export const ToolsHeaderCode = () => {
  const language = 'html';
  const codeString = `
  // FHNW - Tools Header
  <nav
    className="navbar navbar-expand-lg navbar-light"
    role="navigation"
  >
    <a className="navbar-brand">
      <img
        src=""
        alt="FHNW - Fachhochschule Nordwestschweiz"
        height=""
        width=""
      />
    </a>      

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="navbarId"
      aria-controls=""
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span> Menü
    </button>

    {/* MAIN NAVIGATION */}
    <div className="collapse navbar-collapse" id="navbarId">
      <ul className="navbar-nav mr-auto mt-2 mt-md-0">
        <li className="nav-item">
          <a className="nav-link" aria-current="page">
            Home
          </a>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="navbarCorporate"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Single Dropdown
          </a>
    
          <ul className="dropdown-menu" aria-labelledby="navbarCorporate">
            <li>
              <a className="dropdown-item" title="Webdienste">
                Subitem I
              </a>
            </li>
            <li>
              <a className="dropdown-item" title="Tools und Services">
                Subitem II
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown has-megamenu">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            data-bs-toggle="dropdown"
          >
            Megamenu
          </a>
          <div className="dropdown-menu megamenu" role="menu">
            <MegaMenuDemo title="Metatitle" />
          </div>
        </li>
        <li>
          <a className="nav-link ">Topic II</a>
        </li>
      </ul>
    </div>

    {/* LANGUAGE MENU */}
    <div className="collapse navbar-collapse d-flex justify-content-end d-none">
      <div className="language-menu border-primary border-end px-4">
        <ul className="navbar-nav mr-auto mt-2 mt-md-0 gap-2">
          <li className="nav-item">              
            <a
              href=""
              className="btn btn-outline-secondary btn-sm bg-primary text-white px-2"
              aria-current="page"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Demonstration purposes only"
            >
              DE
            </a>
          </li>
          <li className="nav-item">              
            <a
              href=""
              className="btn btn-outline-secondary bg-transparent btn-sm px-2"
              aria-current="page"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Demonstration purposes only"
            >
              EN
            </a>
          </li>
        </ul>
      </div>

      {/* USER DROPDOWN */}
      <ul className="navbar-nav mr-auto mt-2 mt-md-0 px-3">
        <li className="nav-item dropdown">
          <a
            href="#"
            className="nav-link dropdown-toggle d-flex align-items-center"
            id="navbarDropdown3"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src=""
              className="rounded-circle"
              height="22"
              alt="Avatar"
              loading="lazy"
            />
          </a>
          <ul
            className="dropdown-menu dropdown-menu-end"
            aria-labelledby="navbarDropdown3"
          >
            <li>
              
            
            <a
              href=""
              target="_blank"
              className="dropdown-item"
              title=""
            >
              My Profile
            </a>
            </li>
            <li>
              <a
                href=""
                target="_blank"
                className="dropdown-item"
                title="Bootstrap v3"
              >
                Settings
              </a>
            </li>
            <li>                
              <a
                href=""
                target="_blank"
                className="dropdown-item"
                title="Bootstrap v3"
              >
                Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
  `;

  return (
    <>
      <ToastHighLighter
        name={'button'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};

export const ToolsHeaderTitleCode = () => {
  const language = 'html';
  const codeString = `
  // Tools-Header with project title
  <nav
      class="navbar navbar-expand-lg navbar-light"
      role="navigation" style="min-height: 60px"
    >
      <a href="" class="navbar-brand">
        <img
          src=""
          alt="FHNW - Fachhochschule Nordwestschweiz"
          height=""
          width=""
        />
        <span class="navbar-title">Projekttitel</span>
      </a> 
      <span class="navbar-title d-sm-none">Projekttitel</span>
    </nav>
  `;

  return (
    <>
      <ToastHighLighter
        name={'toolsheadertitle'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};
